import React, { createContext, useContext } from 'react';
import { useSearchParams } from 'react-router-dom';

const EmbedContext = createContext(false);

export const useEmbed = () => useContext(EmbedContext);

export const EmbedProvider = ({ children }) => {
  const [searchParams] = useSearchParams();
  const isEmbed = searchParams.get('embed') === 'true';
  
  return (
    <EmbedContext.Provider value={isEmbed}>
      {children}
    </EmbedContext.Provider>
  );
};

export default EmbedContext;
